import { useIsAuthenticated, useMsal } from '@azure/msal-react'
import { useNavigate } from 'react-router-dom'

import { usePostAuthLogoutMutation } from '@/api'
import { PATH } from '@/const'
import { resetStoreLogout } from '@/state/store'

export const useLogout = () => {
  const [mutate, statusProperties] = usePostAuthLogoutMutation()
  const navigate = useNavigate()
  const isAuthenticated = useIsAuthenticated()
  const { instance: msalInstance } = useMsal()

  async function logout() {
    await mutate()
    resetStoreLogout()
    if (isAuthenticated) msalInstance.logoutPopup()
    navigate(PATH.login)
  }

  return [logout, statusProperties] as const
}
